import { createUseStyles } from 'react-jss';

export const useStyles = createUseStyles({
  offscreen: {
    position: 'fixed',
    left: -10000,
    top: 0,
    pointerEvents: 'none',
  },
  page: {
    width: 720,
    boxSizing: 'border-box',
    padding: 48,
    background: '#ffffff',
    color: '#111827',
    fontFamily: 'Georgia, "Times New Roman", Times, serif',
  },
  title: {
    margin: '0 0 36px',
    fontSize: 28,
    fontWeight: 700,
    lineHeight: 1.3,
    textAlign: 'left',
  },
  days: {
    display: 'flex',
    flexDirection: 'column',
    gap: 28,
  },
  day: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  dayHeading: {
    margin: 0,
    fontSize: 20,
    fontWeight: 700,
    lineHeight: 1.3,
    textDecoration: 'underline',
    textUnderlineOffset: 4,
  },
  period: {
    margin: 0,
    fontSize: 16,
    lineHeight: 1.5,
  },
  periodLabel: {
    fontWeight: 700,
  },
});
